'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.create = create;
exports.save = save;
exports.remove = remove;
exports.createChapter = createChapter;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'jai20enmaths-cms/schoollevels/LOAD';
var LOAD_SUCCESS = 'jai20enmaths-cms/schoollevels/LOAD_SUCCESS';
var LOAD_FAIL = 'jai20enmaths-cms/schoollevels/LOAD_FAIL';

var CREATE = 'jai20enmaths-cms/schoollevels/CREATE';
var CREATE_SUCCESS = 'jai20enmaths-cms/schoollevels/CREATE_SUCCESS';
var CREATE_FAIL = 'jai20enmaths-cms/schoollevels/CREATE_FAIL';

var CREATE_CHAPTER = 'jai20enmaths-cms/schoollevels/CREATE_CHAPTER';
var CREATE_CHAPTER_SUCCESS = 'jai20enmaths-cms/schoollevels/CREATE_CHAPTER_SUCCESS';
var CREATE_CHAPTER_FAIL = 'jai20enmaths-cms/schoollevels/CREATE_CHAPTER_FAIL';

var DELETE = 'jai20enmaths-cms/schoollevels/DELETE';
var DELETE_SUCCESS = 'jai20enmaths-cms/schoollevels/DELETE_SUCCESS';
var DELETE_FAIL = 'jai20enmaths-cms/schoollevels/DELETE_FAIL';

var SAVE = 'jai20enmaths-cms/schoollevels/SAVE';
var SAVE_SUCCESS = 'jai20enmaths-cms/schoollevels/SAVE_SUCCESS';
var SAVE_FAIL = 'jai20enmaths-cms/schoollevels/SAVE_FAIL';

var initialState = {
  loaded: false,
  loading: false,
  error: undefined,
  saving: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result.items,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case SAVE:
      return (0, _extends3.default)({}, state, {
        saving: true
      });
    case SAVE_SUCCESS:
      var updatedSchoolLevel = action.result;
      var levels = state.data.filter(function (level) {
        return level._id !== updatedSchoolLevel._id;
      });
      console.log(levels);
      levels.push(updatedSchoolLevel);
      return (0, _extends3.default)({}, state, {
        saving: false,
        error: null,
        data: levels
      });
    case SAVE_FAIL:
      return (0, _extends3.default)({}, state, {
        saving: false,
        error: action.error
      });
    case CREATE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case CREATE_SUCCESS:
      var data = state.data;
      data.push(action.result);
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: data,
        error: null
      });
    case CREATE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case CREATE_CHAPTER:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case CREATE_CHAPTER_SUCCESS:
      var _action$result = action.result,
          _id = _action$result._id,
          rank = _action$result.rank,
          schoolLevelId = _action$result.schoolLevelId;

      var schoolLevels = state.data;
      schoolLevels.forEach(function (schoolLevel) {
        if (schoolLevel._id === schoolLevelId) {
          schoolLevel.chapters.push({
            rank: rank,
            _id: _id
          });
        }
      });
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: schoolLevels,
        error: null
      });
    case CREATE_CHAPTER_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case DELETE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case DELETE_SUCCESS:
      var oldData = state.data;
      var newData = oldData.filter(function (schoolLevel) {
        return schoolLevel._id !== action.schoolLevel._id;
      });
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: newData,
        error: null
      });
    case DELETE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.schoolLevels && globalState.schoolLevels.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/school_level');
    }
  };
}

function create(schoolLevel) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: function promise(client) {
      return client.post('/school_level', { data: schoolLevel });
    }
  };
}

function save(schoolLevel) {
  schoolLevel.chapters.forEach(function (chapterReference, index) {
    schoolLevel.chapters[index] = {
      _id: chapterReference._id._id,
      rank: chapterReference.rank
    };
  });
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.patch('/school_level/' + schoolLevel._id, { data: schoolLevel });
    }
  };
}

function remove(schoolLevel) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.del('/school_level/' + schoolLevel._id);
    },
    schoolLevel: schoolLevel
  };
}

function createChapter(data) {
  return {
    types: [CREATE_CHAPTER, CREATE_CHAPTER_SUCCESS, CREATE_CHAPTER_FAIL],
    promise: function promise(client) {
      return client.post('/chapter', { data: data });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/schoollevels.js
// module id = 77
// module chunks = 0